/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'recharge': {
    width: 30,
    height: 30,
    viewBox: '0 0 30 30',
    data: '<path pid="0" d="M5 15h10m0 0h10m-10 0V5m0 10v10" _stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})
